import { render, staticRenderFns } from "./CargoTracking.vue?vue&type=template&id=85028310&scoped=true"
import script from "./CargoTracking.vue?vue&type=script&lang=js"
export * from "./CargoTracking.vue?vue&type=script&lang=js"
import style0 from "./CargoTracking.vue?vue&type=style&index=0&id=85028310&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85028310",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85028310')) {
      api.createRecord('85028310', component.options)
    } else {
      api.reload('85028310', component.options)
    }
    module.hot.accept("./CargoTracking.vue?vue&type=template&id=85028310&scoped=true", function () {
      api.rerender('85028310', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/CargoTracking.vue"
export default component.exports